import { render } from "./SidebarTrafficInfo.vue?vue&type=template&id=35439352&ts=true"
import script from "./SidebarTrafficInfo.vue?vue&type=script&lang=ts"
export * from "./SidebarTrafficInfo.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Episcenter\\smartCity\\smartcity\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__